import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { getSettingAdyenEligibleCountries } from "@faire/help-center-utils/settings/getSettingAdyenEligibleCountries";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import React from "react";

import { GoToPayoutSettingsCTA } from "./ctas";
import { CANPayoutsIA } from "./instantAnswersComponents/payments/CANPayoutsIA";
import { EligibleAdyenCountriesPayoutsIA } from "./instantAnswersComponents/payments/EligibleAdyenCountriesPayoutsIA";
import { USPayoutsIA } from "./instantAnswersComponents/payments/USPayoutsIA";

export const setUpPayouts: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => getAnswer(context, strictLocalize).getTitle(),
  descriptionBuilder: (context) =>
    getAnswer(context, strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => SETTING_UP_PAYOUTS_TITLE(strictLocalize),
    getDescription: () => SETTING_UP_PAYOUTS_DESCRIPTION(context),
  };
};

const SETTING_UP_PAYOUTS_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Setting up payouts",
    description: {
      text: "Title for the answer of how to set up payouts in the self-serve portal",
    },
  });

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) =>
  GoToPayoutSettingsCTA(strictLocalize);

const SETTING_UP_PAYOUTS_DESCRIPTION = (context: InstantAnswerContext) => {
  const { brand } = context;
  if (!brand || !brand.based_in) {
    return [];
  }
  if (getSettingAdyenEligibleCountries().includes(brand.based_in)) {
    return <EligibleAdyenCountriesPayoutsIA />;
  } else if (brand?.based_in === "CAN") {
    return <CANPayoutsIA />;
  } else {
    return <USPayoutsIA />;
  }
};
